import Button from '../Button/Button'
import styles from './Hero.module.scss'

function Hero() {
    // Данные из твоего старого KeyFeatures, переделанные под компактные теги
    const features = [
        '3500+ учеников',
        'В 3 районах Казани',
        'Имеется лицензия',
        'Группы и индивидуально',
		'Онлайн и очные занятия'
    ];

    return (
        <div className={styles.hero}>
            <div className={styles.heroContent}>
                
                {/* Левая часть - Текст, Кнопки, Отзывы, Теги */}
                <div className={styles.textContent}>
                    <div className={styles.badge}>IT-школа для детей от 4 до 17 лет</div>
                    
                    <h1 className={styles.title}>
                        Откройте мир <span className={styles.highlight}>IT</span><br />
                        для вашего ребенка
                    </h1>
                    
                    <p className={styles.description}>
                        От первых шагов до создания собственных игр и сайтов. Развиваем логику, учим программировать и работать в команде — заложите фундамент успешного будущего уже сегодня.
                    </p>
                    
                    <div className={styles.actions}>
                        <Button />
                        
                        {/* Вторая кнопка, как на скрине */}
                        {/* <button className={styles.secondaryBtn}>
                            <div className={styles.playIcon}>▶</div>
                            <span>Смотреть видео</span>
                        </button> */}
                    </div>

                    {/* Блок с отзывами (как на скрине) */}
                    <div className={styles.reviewsBlock}>
                        <div className={styles.avatars}>
                            {/* Можешь вставить реальные фото учеников/родителей */}
                            <img src="/img/avatars/avatar1.png" alt="" onError={(e) => e.target.style.display='none'} />
                            <img src="/img/avatars/avatar2.png" alt="" onError={(e) => e.target.style.display='none'} />
                            <img src="/img/avatars/avatar3.png" alt="" onError={(e) => e.target.style.display='none'} />
                            {/* <div className={styles.avatarPlus}>+</div> */}
                        </div>
                        <div className={styles.ratingInfo}>
                            <div className={styles.stars}>⭐⭐⭐⭐⭐</div>
                            <span className={styles.reviewsCount}><b>120+ отзывов родителей</b></span>
                        </div>
                    </div>

                    {/* Ключевые особенности в виде тегов (вместо KeyFeatures) */}
                    <div className={styles.tagsContainer}>
                        {features.map((feat, i) => (
                            <div key={i} className={styles.tagItem}>
                                {feat}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Правая часть - Картинка */}
                <div className={styles.imageContent}>
                    <img src='/img/Hero/3dcartMain.png' alt='Прогиум ученик' />
                </div>
                
            </div>
        </div>
    )
}

export default Hero
